<template>
  <div class="box-center-wrapper">
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64" color="#0096Ab"></v-progress-circular>
    </v-overlay>
    
    <div v-if="!overlay">
      <!-- Page Title Section -->
      <div class="page-header">
        <div class="title-container">
          <div class="title-icon">
            <v-icon size="36" color="#ffffff">mdi-safe</v-icon>
          </div>
          <h1 class="page-title">الصناديق</h1>
          <div class="title-divider"></div>
        </div>
        <p class="page-subtitle">نظرة عامة على صناديق الشركة بالعملات المختلفة</p>
      </div>

      <!-- Currency Boxes -->
      <v-row class="currency-boxes" no-gutters justify="center">
        <!-- Dinar Box -->
        <v-col cols="12" md="5">
          <div class="box-container">
            <v-card 
              elevation="8" 
              class="modern-box dinar-box" 
              rounded="xl"
            >
              <div class="box-header">
                <div class="icon-wrapper dinar-icon">
                  <v-icon size="32" color="white">mdi-cash</v-icon>
                </div>
                <h3 class="box-title">صندوق الدينار</h3>
              </div>
              
              <div class="amount-display">
                <h2 class="amount-text dinar-amount">
                  {{
                    (allExpenses.dinarReceipt - allExpenses.dinarExpenses).toLocaleString("en-US", {
                      style: "currency",
                      currency: "IQD",
                    })
                  }}
                </h2>
              </div>
              
              <div class="box-footer">
                <span class="balance-label">الرصيد بالدينار العراقي</span>
              </div>
              
              <div class="box-details">
                <div class="detail-row">
                  <span class="detail-label">المقبوضات:</span>
                  <span class="detail-value income-text">
                    {{ (allExpenses.dinarReceipt || 0).toLocaleString() }} د.ع
                  </span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">المصروفات:</span>
                  <span class="detail-value expenses-text">
                    {{ (allExpenses.dinarExpenses || 0).toLocaleString() }} د.ع
                  </span>
                </div>
              </div>
            </v-card>
          </div>
        </v-col>

        <!-- Dollar Box -->
        <v-col cols="12" md="5">
          <div class="box-container">
            <v-card 
              elevation="8" 
              class="modern-box dollar-box" 
              rounded="xl"
            >
              <div class="box-header">
                <div class="icon-wrapper dollar-icon">
                  <v-icon size="32" color="white">mdi-currency-usd</v-icon>
                </div>
                <h3 class="box-title">صندوق الدولار</h3>
              </div>
              
              <div class="amount-display">
                <h2 class="amount-text dollar-amount">
                  {{
                    (allExpenses.dollarReceipt - allExpenses.dollarExpenses).toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })
                  }}
                </h2>
              </div>
              
              <div class="box-footer">
                <span class="balance-label">الرصيد بالدولار الأمريكي</span>
              </div>
              
              <div class="box-details">
                <div class="detail-row">
                  <span class="detail-label">المقبوضات:</span>
                  <span class="detail-value income-text">
                    ${{ (allExpenses.dollarReceipt || 0).toLocaleString() }}
                  </span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">المصروفات:</span>
                  <span class="detail-value expenses-text">
                    ${{ (allExpenses.dollarExpenses || 0).toLocaleString() }}
                  </span>
                </div>
              </div>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    overlay: false,
    allExpenses: [],
  }),
  created() {
    this.initialData();
  },
  methods: {
    initialData() {
      let self = this;

      self.overlay = true;

      self.$http
        .all([
          self.$http.get(`${self.$store.state.apiUrl}/expensesStatistics`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
        ])
        .then(
          self.$http.spread((allExpenses) => {
            self.allExpenses = allExpenses.data;
            console.log(self.allExpenses);
            self.overlay = false;
          })
        )
        .catch((error) => {
          self.overlay = false;
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.box-center-wrapper {
  padding: 20px;
}

/* Page Header Styles */
.page-header {
  text-align: center;
  margin-bottom: 40px;
  padding: 32px 0;
  position: relative;
}

.title-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 12px;
  position: relative;
}

.title-icon {
  background: linear-gradient(135deg, #0096Ab 0%, #00BCD4 100%);
  width: 64px;
  height: 64px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(0, 150, 171, 0.3);
  position: relative;
}

.title-icon::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 100%);
  border-radius: 20px;
  pointer-events: none;
}

.page-title {
  font-size: 42px;
  font-weight: 800;
  margin: 0;
  background: linear-gradient(135deg, #0096Ab 0%, #00BCD4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 4px 8px rgba(0, 150, 171, 0.1);
  letter-spacing: 2px;
}

.title-divider {
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, #0096Ab 0%, #00BCD4 100%);
  border-radius: 2px;
  position: relative;
}

.title-divider::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  background: #00BCD4;
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba(0, 188, 212, 0.3);
}

.page-subtitle {
  font-size: 18px;
  color: #6B7280;
  margin: 0;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.currency-boxes {
  gap: 24px;
}

.box-container {
  padding: 0 12px;
}

.modern-box {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  min-height: 280px;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.modern-box:hover {
  transform: translateY(-6px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12) !important;
}

.dinar-box {
  border-top: 4px solid #F59E0B;
}

.dollar-box {
  border-top: 4px solid #10B981;
}

.box-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px 24px 16px 24px;
}

.icon-wrapper {
  width: 64px;
  height: 64px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
}

.dinar-icon {
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
}

.dollar-icon {
  background: linear-gradient(135deg, #10B981 0%, #059669 100%);
}

.box-title {
  font-size: 20px;
  font-weight: 600;
  color: #1F2937;
  margin: 0;
  flex: 1;
  min-width: 0;
}

.amount-display {
  padding: 16px 24px 8px 24px;
  text-align: center;
}

.amount-text {
  font-size: 32px;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
  word-break: break-word;
}

.dinar-amount {
  color: #D97706;
}

.dollar-amount {
  color: #059669;
}

.box-footer {
  padding: 8px 24px 16px 24px;
  text-align: center;
}

.balance-label {
  font-size: 14px;
  color: #6B7280;
  font-weight: 500;
  background: rgba(0, 0, 0, 0.03);
  padding: 8px 16px;
  border-radius: 20px;
  display: inline-block;
}

.box-details {
  padding: 16px 24px 24px 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  background: rgba(0, 0, 0, 0.02);
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.detail-row:last-child {
  margin-bottom: 0;
}

.detail-label {
  font-size: 14px;
  color: #6B7280;
  font-weight: 500;
}

.detail-value {
  font-size: 14px;
  font-weight: 600;
}

.income-text {
  color: #059669;
}

.expenses-text {
  color: #DC2626;
}

/* Responsive Design */
@media (max-width: 960px) {
  .currency-boxes {
    gap: 16px;
  }
  
  .box-container {
    padding: 0 8px;
    margin-bottom: 16px;
  }
  
  .box-center-wrapper {
    padding: 16px;
  }
  
  .page-header {
    padding: 24px 0;
    margin-bottom: 32px;
  }
  
  .title-container {
    flex-direction: column;
    gap: 12px;
  }
  
  .title-icon {
    width: 56px;
    height: 56px;
  }
  
  .title-icon .v-icon {
    font-size: 28px !important;
  }
  
  .page-title {
    font-size: 32px;
  }
  
  .page-subtitle {
    font-size: 16px;
  }
  
  .modern-box {
    min-height: 260px;
  }
  
  .box-header {
    padding: 20px 20px 12px 20px;
    gap: 12px;
  }
  
  .icon-wrapper {
    width: 56px;
    height: 56px;
  }
  
  .icon-wrapper .v-icon {
    font-size: 28px !important;
  }
  
  .box-title {
    font-size: 18px;
  }
  
  .amount-text {
    font-size: 28px;
  }
  
  .amount-display {
    padding: 12px 20px 8px 20px;
  }
  
  .box-footer {
    padding: 8px 20px 12px 20px;
  }
  
  .box-details {
    padding: 12px 20px 20px 20px;
  }
}

@media (max-width: 600px) {
  .currency-boxes {
    flex-direction: column;
    gap: 16px;
  }
  
  .page-title {
    font-size: 28px;
  }
  
  .page-subtitle {
    font-size: 14px;
  }
  
  .amount-text {
    font-size: 24px;
  }
  
  .box-title {
    font-size: 16px;
  }
  
  .balance-label {
    font-size: 12px;
  }
  
  .detail-label,
  .detail-value {
    font-size: 12px;
  }
}

/* For medium screens */
@media (max-width: 1024px) and (min-width: 601px) {
  .page-title {
    font-size: 36px;
  }
  
  .amount-text {
    font-size: 28px;
  }
  
  .box-title {
    font-size: 18px;
  }
}
</style>
